import { TaskComment } from "../../types/TaskComment";
import {
  TaskCommentActions,
  TaskCommentActionList,
} from "../actions/taskCommentAction";

const initialState: TaskComment[] = [];

export const taskCommentReducer = (
  state: TaskComment[] = initialState,
  action: TaskCommentActions,
): TaskComment[] => {
  switch (action.type) {
    case TaskCommentActionList.ADD_TASK_COMMENT:
      return [...state, action.data];

    case TaskCommentActionList.EDIT_TASK_COMMENT:
      return state.map((comment) =>
        comment.id === action.data.id ? { ...action.data } : comment,
      );

    case TaskCommentActionList.FETCH_TASK_COMMENTS:
      return action.data;

    case TaskCommentActionList.DELETE_TASK_COMMENT:
      return state.filter((comment) => comment.id !== action.data);

    default:
      return state;
  }
};
